import type { SiteImage } from "../../config/images";

type ResponsiveImageProps = {
  image: SiteImage;
  className?: string;
  eager?: boolean;
  sizes?: string;
};

export function ResponsiveImage({
  image,
  className,
  eager = false,
  sizes = "(min-width: 960px) 50vw, 100vw",
}: ResponsiveImageProps) {
  return (
    <img
      className={className}
      src={image.src}
      srcSet={image.srcSet}
      sizes={image.srcSet ? sizes : undefined}
      alt={image.alt}
      width={image.width}
      height={image.height}
      loading={eager ? "eager" : "lazy"}
      fetchPriority={eager ? "high" : "auto"}
      decoding="async"
      style={{ objectPosition: image.objectPosition }}
    />
  );
}
